(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire179d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire179d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ik5Sr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d56ea750786f9579$export$2e2bcd8739ae039);
class $d56ea750786f9579$export$2e2bcd8739ae039 {
    constructor(){
        this.orderTable();
        this.paginationTable();
    }
    orderTable() {
        const ancors = document.querySelectorAll(".order-table");
        const urlParams = new URLSearchParams(window.location.search);
        let sortOrder = urlParams.get("order") || "DESC";
        ancors.forEach((ancor)=>{
            const value = ancor.getAttribute("data-order");
            if (value) ancor.addEventListener("click", ()=>{
                sortOrder = sortOrder === "ASC" ? "DESC" : "ASC";
                this.queryURL([
                    {
                        "key": "orderby",
                        "value": value
                    },
                    {
                        "key": "order",
                        "value": sortOrder
                    }
                ]);
            });
        });
    }
    paginationTable() {
        const ancors = document.querySelectorAll(".pagination");
        ancors.forEach((ancor)=>{
            const value = ancor.getAttribute("data-page");
            if (value) ancor.addEventListener("click", ()=>{
                this.queryURL([
                    {
                        "key": "table-page",
                        "value": value
                    }
                ]);
            });
        });
    }
    queryURL(paramsArray) {
        const urlParams = new URLSearchParams(window.location.search);
        paramsArray.forEach(({ key: key, value: value })=>{
            urlParams.delete(key);
            urlParams.append(key, value);
        });
        window.location.replace(`${location.origin + location.pathname}?${urlParams.toString()}`);
    }
}

});


parcelRequire("ik5Sr");
})();
//# sourceMappingURL=table.js.map
